/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import SVGIcons from '@components/SVGIcon';
import {
  CountrySelectProps as Props,
  SelectIconProps,
  optionType,
} from './CountrySelect.type';
import { Image } from '@components/Image';

import cn from './CountrySelect.module.scss';

export function CountrySelect(props: Props) {
  const selectedOption = React.useMemo(() => {
    return getSelectedOption(props.options, props.value);
  }, [props.options, props.value]);

  const FlagImage = ({ type }: { type: string }): JSX.Element => {
    const url = `https://purecatamphetamine.github.io/country-flag-icons/3x2/${type}.svg`;
    return <Image url={url} alt={type} width={17} />;
  };

  const renderValue = () => {
    if (selectedOption)
      return (
        <div className={cn.renderValue}>
          <FlagImage type={selectedOption.flagCode} />
          <span>{selectedOption.code}</span>
        </div>
      );
  };

  const onChangeSelection = (e: SelectChangeEvent) => {
    props.onChange(e.target.value);
  };

  return (
    <div className={cn.PhoneInputCountry}>
      <Select
        disabled={props.disabled}
        name={props.name}
        value={props.value}
        onChange={onChangeSelection}
        renderValue={renderValue}
        IconComponent={SelectIcon}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 250,
              maxWidth: 200,
              marginTop: 1,
            },
          },
        }}
        className={cn.sel}
      >
        {props.options.map((option: any) => (
          <MenuItem
            key={option.value}
            value={option.value}
            className={cn.sel_option}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

const SelectIcon = (props: SelectIconProps) => (
  <span className={`${props.className} ${cn.sel_icon}`}>
    <SVGIcons type={'downarrow-svg'} />
  </span>
);

function getSelectedOption(options: optionType[], value: string) {
  for (const option of options) {
    if (option.value === value) {
      return option;
    }
  }
}
